class QuickFilters extends HTMLElement {
  connectedCallback() {
    this.handleClick = this.handleClick.bind(this);
    this.handleFacetFetchComplete = this.handleFacetFetchComplete.bind(this);

    this.addEventListener('click', this.handleClick);
    window.addEventListener('custom:facets:fetch:complete', this.handleFacetFetchComplete);

    this.updateLinkState();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    window.removeEventListener('custom:facets:fetch:complete', this.handleFacetFetchComplete);
  }

  handleFacetFetchComplete() {
    this.updateLinkState();
  }

  getCurrentSearchParamsString() {
    const facetComponent = document.querySelector('facet-filters-form');
    const form = facetComponent ? facetComponent.querySelector('form') : null;

    if (facetComponent && form && typeof facetComponent.createSearchParams === 'function') {
      return facetComponent.createSearchParams(form);
    }

    return window.location.search.slice(1);
  }

  updateLinkState(searchParamsString = this.getCurrentSearchParamsString()) {
    const quickFilterLinks = this.querySelectorAll('[data-quick-filter-link]');
    if (!quickFilterLinks.length) return;

    const searchParams = new URLSearchParams(searchParamsString);

    quickFilterLinks.forEach((quickFilterLink) => {
      const param = quickFilterLink.getAttribute('data-quick-filter-param');
      const value = quickFilterLink.getAttribute('data-quick-filter-value') || '';
      if (!param) return;

      const activeValues = searchParams.getAll(param);
      const isActive = value === '' ? activeValues.length === 0 : activeValues.includes(value);

      quickFilterLink.classList.toggle('underline', isActive);
      quickFilterLink.classList.toggle('underline-offset-4', isActive);
    });
  }

  dispatchApplyQuickFilter({ param, value, shouldActivate, event }) {
    window.dispatchEvent(
      new CustomEvent('custom:quick-filters:apply', {
        detail: {
          param,
          value,
          shouldActivate,
          event,
        },
      }),
    );
  }

  handleClick(event) {
    const quickFilterLink = event.target.closest('[data-quick-filter-link]');
    if (!quickFilterLink || !this.contains(quickFilterLink)) return;

    event.preventDefault();

    const param = quickFilterLink.getAttribute('data-quick-filter-param');
    const value = quickFilterLink.getAttribute('data-quick-filter-value') || '';
    if (!param) return;

    const currentSearchParams = new URLSearchParams(this.getCurrentSearchParamsString());

    // "All" clears all values for this quick-filter param
    if (!value) {
      currentSearchParams.delete(param);
      this.updateLinkState(currentSearchParams.toString());
      this.dispatchApplyQuickFilter({ param, value: '', shouldActivate: false, event });
      return;
    }

    const activeValues = currentSearchParams.getAll(param);
    const isCurrentlyActive = activeValues.includes(value);
    const nextShouldActivate = !isCurrentlyActive;

    if (isCurrentlyActive) {
      // Remove just the clicked value, keep other selected values.
      const nextValues = activeValues.filter((v) => v !== value);
      currentSearchParams.delete(param);
      nextValues.forEach((v) => currentSearchParams.append(param, v));
    } else {
      // Add just the clicked value, keep other selected values.
      currentSearchParams.append(param, value);
    }

    this.updateLinkState(currentSearchParams.toString());
    this.dispatchApplyQuickFilter({ param, value, shouldActivate: nextShouldActivate, event });
  }
}

customElements.define('quick-filters', QuickFilters);

